import React from "react";
import styled from "@emotion/styled";
import { useDispatch } from "react-redux";
import { Panel } from "@fluentui/react";
import { useLangContext } from "@layouts/home/LangContext";
import { sessionSlice } from "maven-lib/dist/states";
import DrawerContent from "./DrawerContent";
import { ECOA_COMMON_LANG } from "@maven-msg/lang/ecoa";
import { MvnLanguage, MvnMessage } from "@maven-msg/lib/Message";

const StyledMenuDrawerContentWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const getFaqUrl = (lang: MvnLanguage) => {
  switch (lang) {
    case MvnLanguage.KO:
      return "https://jnpmedi.atlassian.net/wiki/x/5YDsDg";
    default:
      return "https://jnpmedi.atlassian.net/wiki/x/-AAIDw";
  }
};

const renderPanelHeader = () => {
  return <strong className="app-hybrid-header-panel">{process.env.REACT_APP_NAME}</strong>;
};

export interface MenuDrawerProps {
  isOpen: boolean;
  onDismiss: () => void;
}

export const MenuDrawer = ({ isOpen, onDismiss }: MenuDrawerProps) => {
  const dispatch = useDispatch();

  const { lang, setLang } = useLangContext();

  const getCheckProps = (language: MvnLanguage, disabled?: boolean) => {
    return {
      checked: language === lang,
      disabled,
      onClick: () => setLang(language),
    };
  };

  return (
    <Panel
      isOpen={isOpen}
      onDismiss={onDismiss}
      onRenderHeader={renderPanelHeader}
      styles={{
        navigation: { justifyContent: "space-between", padding: "0 16px", alignItems: "center" },
        closeButton: { marginRight: "unset", color: "#4D5358" },
        content: { paddingLeft: "unset", paddingRight: "unset", height: "100%" },
        commands: { marginBottom: "1rem" },
        scrollableContent: { height: "100%" },
      }}
    >
      <StyledMenuDrawerContentWrapper>
        <DrawerContent.Title title={MvnMessage(ECOA_COMMON_LANG.ECOA_COMMON_LANGUAGE_SETTINGS)} />
        <DrawerContent.Check label="한국어" {...getCheckProps(MvnLanguage.KO)} />
        <DrawerContent.Check label="English" {...getCheckProps(MvnLanguage.EN)} />
        <DrawerContent.Check label="Français" {...getCheckProps(MvnLanguage.FR)} />
        <DrawerContent.Check label="Nederlands" {...getCheckProps(MvnLanguage.NL)} />
        <DrawerContent.Divider />
        <DrawerContent.Link label="FAQ" link={getFaqUrl(lang)} />
        <DrawerContent.SurveyCompleteButton
          text={MvnMessage(ECOA_COMMON_LANG.ECOA_COMMON_SURVEY_COMPLETED)}
          onClick={() => dispatch(sessionSlice.actions.signOut())}
        />
      </StyledMenuDrawerContentWrapper>
    </Panel>
  );
};
